'use client';

import { usePathname } from 'next/navigation';

import { Footer } from '@/app/_components/DonationTemp/FooterTemp';
import { DONATION_ROUTES, ROUTES } from '@/constants';
import { useLayoutType } from '@/hooks/useLayoutType';

import { DonationDesktopHeader } from './DonationDesktopHeader';

interface DonationLayoutProps {
  children: React.ReactNode;
}

/**
 * footer를 제외하고 렌더링할 페이지 (정규표현식 패턴)
 */
const EXCLUDED_FOOTER_PATTERNS: RegExp[] = [
  /^\/donation\/my/,
  /^\/donation\/gifts\/.+\/order$/,
  /^\/donation\/invite\/.+$/,
  /^\/donation\/gifts\/.+\/order\/.+\/complete$/,
  /^\/donation\/callback\/.+\/.+$/,
  /^\/donation\/callback\/.+$/,
  /^\/donation\/donation-reservation\/.+$/,
  /^\/donation\/event\/market/,
  /^\/donation\/event\/stamp-2/,
  /^\/donation\/cart$/, // 장바구니 페이지
  /^\/donation\/cart\/order$/, // 장바구니 주문 페이지
];

/**
 * footer를 제외하고 렌더링할 페이지
 */
const EXCLUDED_FOOTER_PATHNAMES: string[] = [
  DONATION_ROUTES.MY_INVITE.pathname,
  DONATION_ROUTES.HOMETOWN_BUSINESS_ORDER.pathname,
  DONATION_ROUTES.DONATION_INVITE.pathname,
  DONATION_ROUTES.GIFTS_SEARCH.pathname,
  DONATION_ROUTES.STAMP.pathname,
  DONATION_ROUTES.GALAXY_WATCH.pathname,
  DONATION_ROUTES.KB_CHECK_CARD.pathname,
  ROUTES.LOGIN.pathname,
  ROUTES.JOIN_COMMON.pathname,
  ROUTES.JOIN_COMPLETE.pathname,
  ROUTES.EASY_CERTIFICATION.pathname,
  ROUTES.EASY_CERTIFICATION_CALLBACK.pathname,
  ROUTES.LOCALFESTA.pathname,
  ROUTES.LOCALFESTA_APPLY.pathname,
  '/donation' + ROUTES.LOCALFESTA.pathname,
  '/donation' + ROUTES.LOCALFESTA_APPLY.pathname,
  DONATION_ROUTES.MARKET.pathname,
];

export const DonationLayout = ({ children }: DonationLayoutProps) => {
  const pathname = usePathname();
  const { layoutType } = useLayoutType();
  const isDonationLayout = layoutType === 'donation';

  // 현재 경로가 제외 패턴과 매칭되는지 확인
  const shouldShowFooter =
    isDonationLayout &&
    !EXCLUDED_FOOTER_PATTERNS.some((pattern) => pattern.test(pathname || '')) &&
    !EXCLUDED_FOOTER_PATHNAMES.includes(pathname || '');

  return (
    <>
      {isDonationLayout && <DonationDesktopHeader />}
      {children}
      {shouldShowFooter ? <Footer /> : null}
    </>
  );
};
